'use client';
import {Text} from "@web-libs/ui/ui-components/typo/text";
import {StyledLink, StyledLinkButton} from "@web-libs/ui/ui-components/typo/styled-link";
import {useTageaRouter} from "@web-libs/core/routing/application/use-tagea-router.concern";
import {Color} from "@web-libs/features/colors/application/colors";

export type BottomNavigationProps = {
    preText: string,
    linkText: string,
    relativeRoute?: string,
    onClick?: () => void,
    color?: Color
}

export const BottomNavigation = (props:BottomNavigationProps) => {

    const _color: Color | undefined = props.color;
    const unobstrusiveColor: Color | undefined = !_color ? undefined : _color === "dark" ? "unobtrusive" : "light"

    const {preText, linkText, relativeRoute, onClick} = props
    const router = useTageaRouter()

    const button = onClick ? <StyledLinkButton text={linkText} color={_color} onClick={onClick}></StyledLinkButton> : null
    const link = relativeRoute ? <StyledLink href={router.getLink(relativeRoute)} text={linkText} color={_color}></StyledLink> : null

    return (
        <div>
            <Text style={{marginRight:4}} color={unobstrusiveColor} size={'sm'}>{preText}</Text>
            {button ?? link}
        </div>
    )
}
